import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TagsFilterItem from 'components/tags-filter-item';
import cn from 'classnames';

const TagsFilter = ({
  name,
  items,
  asSkeleton,
  // eslint-disable-next-line no-unused-vars
  onChange = ({ name, items }) => {},
  itemCountPlaceholder,
  className,
}) => {
  const [selectedItem, setSelectedItem] = useState(items.find(x => x.selected));

  useEffect(() => {
    setSelectedItem(items.find(x => x.selected));
  }, [items]);

  const handleItemClick = clickedItem => {
    const newSelectedItem = clickedItem === selectedItem ? null : clickedItem;
    setSelectedItem(newSelectedItem);
    const currentItems = items.map(item => {
      return { ...item, selected: item === newSelectedItem };
    });
    onChange({ name: name, items: currentItems });
  };

  return (
    <ul
      className={cn('tags-filter', className, {
        'tags-filter_has-selected': selectedItem,
      })}
    >
      {items &&
        items.map((item, index) => {
          const isItemSelected = item.value === selectedItem?.value;
          return (
            <li
              key={item.value}
              className={cn('tags-filter__item', {
                'tags-filter__item_selected': isItemSelected,
              })}
            >
              <TagsFilterItem
                {...item}
                itemIndex={index}
                asSkeleton={asSkeleton}
                selected={isItemSelected}
                onClick={() => handleItemClick(item)}
                itemCountPlaceholder={itemCountPlaceholder}
                className="tags-filter__item-button"
              />
            </li>
          );
        })}
    </ul>
  );
};

TagsFilter.propTypes = {
  name: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.exact(TagsFilterItem.propTypes)),
  onChange: PropTypes.func,
  asSkeleton: PropTypes.bool,
  itemCountPlaceholder: PropTypes.string,
  className: PropTypes.string,
};

TagsFilter.viewModelMeta = {
  className: 'ignore',
  asSkeleton: 'ignore',
  itemCountPlaceholder: 'ignore',
  onChange: 'ignore',
};

export default TagsFilter;
